import { render, staticRenderFns } from "./FileThumbnail.vue?vue&type=template&id=fb390c94&scoped=true&"
import script from "./FileThumbnail.vue?vue&type=script&lang=ts&"
export * from "./FileThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./FileThumbnail.vue?vue&type=style&index=0&id=fb390c94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb390c94",
  null
  
)

export default component.exports